
const NewsIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
         <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M15.833 17.782v0c.921 0 1.667-.746 1.667-1.667v-5a.834.834 0 0 0-.833-.833h-2.5v5.833c0 .921.746 1.667 1.666 1.667Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M5.833 6.949h5M5.833 10.174h5M5.833 13.665h2.5M14.167 10.282V4.449a.834.834 0 0 0-.834-.834h-10a.834.834 0 0 0-.833.834v11.666c0 .921.746 1.667 1.667 1.667h11.666"
        />
    </svg>
)

export default NewsIcon
